import React from 'react';

interface INoFavorites {
  isNewbuilding: boolean;
}

export const NoFavorites: React.FC<INoFavorites> = ({ isNewbuilding }) => {
  return (
    <div className="c-header-modal__empty-wrapper">
      <div className="c-header-modal__empty">
        <div className={isNewbuilding ? 'c-header-modal__empty-newbuilding' : 'c-header-modal__empty-residential'} />
        <div className="c-header-modal__empty-content">
          <h4 className="c-header-modal__empty-header">
            {isNewbuilding ? 'Здесь будут любимые жилые комплексы' : 'Добавляйте объявления в избранное'}
          </h4>
          <p className="c-header-modal__empty-text">
            {isNewbuilding
              ? 'Добавляйте понравившиеся ЖК в избранноеи будьте в курсе новых предложений'
              : 'Отмечайте интересные объявленияи следите за изменением цены'}
          </p>
        </div>
      </div>
    </div>
  );
};
